import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import TrialExpirationModal from "./Modal/TrialExpirationModal";
import { setUser } from "@/store/auth/authSlice";
import { acknowledgeTrialEnd } from "@/store/membership/membershipActions";

export default function GlobalTrialObserver() {
  const dispatch = useDispatch();
  const { user, isAuthenticated, currentSubscription } = useSelector(
    (state) => state.auth,
  );
  const membership = user?.membership;

  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);
  const [isAcknowledging, setIsAcknowledging] = useState(false);

  useEffect(() => {
    if (
      isAuthenticated &&
      membership?.isTrial &&
      membership?.trialExpired &&
      !membership?.trialAcknowledged
    ) {
      setIsTrialModalOpen(true);
    } else {
      setIsTrialModalOpen(false);
    }
  }, [isAuthenticated, membership]);

  const handleAcknowledgeTrial = async () => {
    setIsAcknowledging(true);
    const result = await dispatch(acknowledgeTrialEnd({ userId: user?.uid }));

    const updatedMembership = {
      ...membership,
      isTrial: false,
      trialAcknowledged: true,
      plan: membership?.plan || "free",
    };

    dispatch(setUser({ ...user, membership: updatedMembership }));
    setIsTrialModalOpen(false);

    setIsAcknowledging(false);
  };

  return (
    <TrialExpirationModal
      isOpen={isTrialModalOpen}
      onConfirm={handleAcknowledgeTrial}
      loading={isAcknowledging}
      trialPlan={membership?.trialPlan}
      fallbackPlan={membership?.plan || "free"}
    />
  );
}
